import * as React from 'react';

const TrashIcon = () => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.3971 1.25C9.73402 1.25 9.09814 1.51339 8.6293 1.98223C8.16046 2.45107 7.89706 3.08696 7.89706 3.75V4.25L5.90004 4.25L5.89706 4.25L5.89409 4.25L4.39706 4.25C3.84478 4.25 3.39706 4.69772 3.39706 5.25C3.39706 5.80229 3.84478 6.25 4.39706 6.25H4.89706V19.5C4.89706 19.9641 5.08144 20.4092 5.40963 20.7374C5.73782 21.0656 6.18294 21.25 6.64706 21.25H18.6471C19.1112 21.25 19.5563 21.0656 19.8845 20.7374C20.2127 20.4092 20.3971 19.9641 20.3971 19.5V6.25H20.8971C21.4493 6.25 21.8971 5.80228 21.8971 5.25C21.8971 4.69772 21.4493 4.25 20.8971 4.25L19.398 4.25L19.3971 4.25L19.3961 4.25L17.3971 4.25V3.75C17.3971 3.08696 17.1337 2.45107 16.6648 1.98223C16.196 1.51339 15.5601 1.25 14.8971 1.25H10.3971ZM15.3971 4.25V3.75C15.3971 3.61739 15.3444 3.49022 15.2506 3.39645C15.1568 3.30268 15.0297 3.25 14.8971 3.25H10.3971C10.2645 3.25 10.1373 3.30268 10.0435 3.39645C9.94974 3.49022 9.89706 3.61739 9.89706 3.75V4.25L15.3971 4.25ZM6.89706 19.25V6.25L18.3971 6.25V19.25H6.89706ZM10.3971 8.75C10.9493 8.75 11.3971 9.19772 11.3971 9.75V15.75C11.3971 16.3023 10.9493 16.75 10.3971 16.75C9.84478 16.75 9.39706 16.3023 9.39706 15.75V9.75C9.39706 9.19772 9.84478 8.75 10.3971 8.75ZM15.8971 9.75C15.8971 9.19772 15.4493 8.75 14.8971 8.75C14.3448 8.75 13.8971 9.19772 13.8971 9.75V15.75C13.8971 16.3023 14.3448 16.75 14.8971 16.75C15.4493 16.75 15.8971 16.3023 15.8971 15.75V9.75Z"
      fill="white"
    />
  </svg>
);

export default TrashIcon;
